import {
  ADD_NEW_DOCUMENTS,
  ADD_NEW_DOCUMENTS_ERR,
  GET_DOCUMENTS,
  GET_DOCUMENTS_ERR,
  GET_UNVERIFIEDDOCUMENTS_ERR,
  GET_UNVERIFIEDDOCUMENTS,
  GET_AUTOPOPULATE_ERR,
  GET_AUTOPOPULATE,
  GET_TEMPLATESCHEMA,
  GET_TEMPLATESCHEMA_ERR,
  GET_SINGLEEMPLOYEE,
  ADD_NEW_UNVERIFIED_DOCUMENTS,
  GET_SINGLEEMPLOYEER

} from "../actions/NewSystemDocuments";

var initialState = {
  systemdocuments: [],
  unverifieddocuments: [],
  unverfied_loader: "some",
  isLoading: "null",
  loader: "null",
  documentLoader: "null",
  autopopulate_loader: "safd",
  autopopulate: {},
  employee: {},
  employer: {},
  templateSchema: {
    properties: {}
  },
  schema_loader: "sfd",
  add_verified_doc_loader: "FSA"
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_DOCUMENTS: {
      return {
        ...state,
        isLoading: "move",
        loader: new Date()
      };
    }

    case ADD_NEW_DOCUMENTS_ERR: {
      return {
        ...state,
        isLoading: "error",
        loader: new Date()
      };
    }

    case GET_DOCUMENTS: {
      return {
        ...state,
        systemdocuments: action.payload,
        documentLoader: new Date()
      };
    }

    case GET_DOCUMENTS_ERR: {
      return {
        ...state,
        documentLoader: new Date()
      };
    }

    case GET_UNVERIFIEDDOCUMENTS: {
      return {
        ...state,
        unverifieddocuments: action.payload,
        unverfied_loader: new Date()
      };
    }

    case GET_UNVERIFIEDDOCUMENTS_ERR: {
      return {
        ...state,
        unverfied_loader: new Date()
      };
    }

    case GET_AUTOPOPULATE: {
      return {
        ...state,
        autopopulate: action.payload,
        autopopulate_loader: new Date()
      };
    }

    case GET_AUTOPOPULATE_ERR: {
      return {
        ...state,
        autopopulate_loader: new Date()
      };
    }

    case GET_TEMPLATESCHEMA: {
      return {
        ...state,
        templateSchema: action.payload,
        schema_loader: new Date()
      };
    }

    case GET_TEMPLATESCHEMA_ERR: {
      return {
        ...state,
        schema_loader: new Date()
      };
    }

    case GET_SINGLEEMPLOYEE: {
      return {
        ...state,
        employee: action.payload
      };
    }
    case GET_SINGLEEMPLOYEER: {
      return {
        ...state,
        employer: action.payload
      };
    }

    case ADD_NEW_UNVERIFIED_DOCUMENTS: {
      return {
        ...state,
        add_verified_doc_loader: new Date()
      };
    }

    default:
      return state;
  }
}
